export default {
  otherCategory: 'Others ({count})',
};
